import { useQuery } from "react-query";
import { getPanicButton } from "../../../../actions/CarrierAgreementMgmt/Security";

export const usePanicButtons = () => {
  const { data, isLoading, refetch } = useQuery(
    "GetPanicButton",
    getPanicButton,
    {
      refetchOnWindowFocus: false,
    }
  );

  return { data, isLoading, refetch };
};
